import { useLayoutEffect, useState } from "react";

const useDropdownOptionsAtTop = (parentRef, optionsListRef) => {
  const [openAtTop, setOpenAtTop] = useState(false);

  useLayoutEffect(() => {
    const listHeightDuringAnimation =
      optionsListRef?.current?.getBoundingClientRect()?.bottom +
      optionsListRef?.current?.offsetHeight * 1.1; // During the opening animation, the list is scaled up to 110%

    if (parentRef?.current?.getBoundingClientRect().bottom < listHeightDuringAnimation) {
      setOpenAtTop(true);
    }
  }, [parentRef, optionsListRef]);

  return openAtTop;
};

export default useDropdownOptionsAtTop;
